//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'd2-table-columns-fixed-controller',
  props: {
    value: {
      default: false
    }
  },
  data: function data() {
    return {
      options: [{
        value: 'left',
        icon: 'el-icon-arrow-left'
      }, {
        value: false,
        icon: 'el-icon-close'
      }, {
        value: 'right',
        icon: 'el-icon-arrow-right'
      }]
    };
  },
  methods: {
    submit: function submit(value) {
      this.$emit('input', value);
      this.$emit('change', value);
    }
  }
};